<script>
	import LayoutPrimary from '$lib/components/layouts/LayoutPrimary.svelte';
	import abcmouseLogo from '$lib/assets/images/home/logo_large_v1.png';
	import { app } from '$lib/stores/app/store';
	import { PAGES } from '$lib/utils/constants';
	import { openModal } from 'svelte-modals';
	import ModalDNSMI from '$lib/components/modals/ModalDNSMI.svelte';
	import ComponentPageHead from '$lib/components/ComponentPageHead.svelte';
	let headerType = 'mouse';
	let error404Source = '/assets-mkt/modules/cdiv-element/404_wo_NMHP-v1.png';
	let primaryFooterContent = {
		links: [
			{
				id: 'trade-mark',
				text: 'TM & © 2007-2025 Age of Learning, Inc. All rights reserved.<br />',
				href: PAGES.EXTERNAL.AOFL,
				aria: 'Age of Learning Inc. Copyright Notice',
				target: '_blank',
				rel: 'noopener noreferrer'
			},
			{
				id: 'terms-conditions',
				text: 'Terms & Conditions',
				href: PAGES.EXTERNAL.TERMS_CONDITIONS,
				aria: 'Terms and Conditions',
				target: '_blank',
				rel: 'noopener noreferrer'
			},
			{
				id: 'privacy-policy',
				text: 'Privacy Policy',
				href: PAGES.EXTERNAL.PRIVACY_POLICY,
				aria: 'Privacy Policy',
				target: '_blank',
				rel: 'noopener noreferrer'
			},
			{
				id: 'do-not-sell',
				text: 'Do Not Sell My Personal&nbsp;Information',
				href: '#do-not-sell',
				aria: 'Do Not Sell My Personal Information',
				type: 'callback',
				callback: () =>
					openModal(ModalDNSMI, {
						modalImageSrc: '/assets-mkt/template/cookie-consent-modal/abc_logo-v1.png'
					})
			},
			{
				id: 'customer-support',
				text: 'Customer Care',
				href: PAGES.EXTERNAL.CUSTOMER_SUPPORT,
				aria: 'Customer Care Support',
				target: '_blank',
				rel: 'noopener noreferrer'
			}
		]
	};

	if ($app.meta.localeCode == 'es-US') {
		error404Source = '/assets-mkt/modules/cdiv-element/404_wo_NMHP_es-v1.png';
		primaryFooterContent = {
			links: [
				{
					id: 'trade-mark',
					text: 'TM & © 2007-2025 Age of Learning, Inc. All rights reserved.<br />',
					href: PAGES.EXTERNAL.AOFL,
					aria: 'Age of Learning Inc. Copyright Notice',
					target: '_blank',
					rel: 'noopener noreferrer'
				},
				{
					id: 'terms-conditions',
					text: 'Términos y condiciones',
					href: PAGES.EXTERNAL.TERMS_CONDITIONS,
					aria: 'Terms and Conditions',
					target: '_blank',
					rel: 'noopener noreferrer'
				},
				{
					id: 'privacy-policy',
					text: 'Política de privacidad',
					href: PAGES.EXTERNAL.PRIVACY_POLICY,
					aria: 'Privacy Policy',
					target: '_blank',
					rel: 'noopener noreferrer'
				},
				{
					id: 'do-not-sell',
					text: 'No vender mi información personal',
					href: '#do-not-sell',
					aria: 'Do Not Sell My Personal Information',
					type: 'callback',
					callback: () =>
						openModal(ModalDNSMI, {
							modalImageSrc: '/assets-mkt/template/cookie-consent-modal/abc_logo-v1.png'
						})
				},
				{
					id: 'customer-support',
					text: 'Asistencia',
					href: PAGES.EXTERNAL.CUSTOMER_SUPPORT,
					aria: 'Customer Care Support',
					target: '_blank',
					rel: 'noopener noreferrer'
				}
			]
		};
	}

	const pageHeadContent = {
		title: 'ABCmouse: Educational Games, Books, Puzzles & Songs for Kids & Toddlers',
		link: [
			{
				rel: 'canonical',
				href: 'https://plus.abcmouse.com/login'
			},
			{
				rel: 'alternate',
				href: 'https://plus.abcmouse.com/login',
				hreflang: 'en'
			},
			{
				rel: 'alternate',
				href: 'https://plus.abcmouse.com/login/es',
				hreflang: 'es'
			}
		],
		metaTag: [
			{
				name: 'description',
				content:
					'ABCmouse.com helps kids learn to read through phonics, and teaches lessons in math, social studies, art, music, and much more. For kids age 2 to Kindergarten.'
			},
			{
				name: 'keywords',
				content:
					'Learn, learning, learn to read, math, early learning, early childhood education, online books, phonics, printables, pbs, pbskids.com, starfall, starfall.com, funbrain, teacher'
			},
			{
				property: 'og:title',
				content: 'ABCmouse.com'
			},
			{
				property: 'og:image',
				content: 'https://img.abcmouse.com/fb/ABCmouse.jpg'
			},
			{
				property: 'og:site_name',
				content: 'ABCmouse.com'
			},
			{
				property: 'og:description',
				content:
					'ABCmouse.com helps kids learn to read through phonics, and teaches lessons in math, social studies, art, music, and much more! For kids ages 2 to 8.'
			},
			{
				property: 'og:url',
				href: 'https://plus.abcmouse.com'
			}
		]
	};
</script>

<ComponentPageHead content={pageHeadContent} />
<LayoutPrimary
	contentClassList="flex flex-col items-center gap-[2.5rem] pb-[4rem]"
	kidsafe
	showLogin
	showSignUp
	{headerType}
	{primaryFooterContent}
>
	<section class="flex w-full flex-col items-center font-poppins">
		<div class="flex w-full flex-col items-center gap-6 sm:gap-9">
			<img src={abcmouseLogo} alt="ABCmouse" class=" h-auto w-[19.2rem] md:w-[29.8rem]" />
			<img
				src={error404Source}
				alt="404 Page Not Found"
				class=" h-auto w-full max-w-[53rem] px-2 sm:max-w-[70rem] sm:px-4"
			/>
		</div>
	</section>
</LayoutPrimary>
